import styled from 'styled-components';

export const Wrapper = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  height: 100%;
  display: ${({ $isSelected }) => ($isSelected ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 16px 0 16px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  align-self: stretch;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  font-weight: 600;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;
